<script lang="ts">
export default {
  name: "AdminNavigation",
};
</script>

<script lang="ts" setup>
import { useI18n } from "@/shared/composables/useI18n";
import logo from "@/images/admin/favicons/favicon.png";
import AppNavigation from "@/shared/components/AppNavigation/index.vue";
import AppNavigationItems from "@/shared/components/AppNavigation/Items/index.vue";
import NavItem from "@/shared/components/AppNavigation/NavItem/index.vue";
import AdminNotificationsNav from "@/admin/components/Notifications/index.vue";
import { routes } from "@/admin/pages/routes";
import { storeToRefs } from "pinia";
import { useSessionStore } from "@/admin/stores/session";
import { checkAccess } from "@/shared/utils/Access";

const { t } = useI18n();

const currentRoute = useRoute();

const sessionStore = useSessionStore();

const mainRoutes = computed(() => {
  return routes.filter(
    (route) => route.meta?.nav === "main" || !route.meta?.nav,
  );
});

const footerRoutes = computed(() => {
  return routes.filter((route) => route.meta?.nav === "footer");
});

const { isAuthenticated, currentUser, resourceAccess } =
  storeToRefs(sessionStore);

const logout = async () => {
  await sessionStore.logout();
};

const hasAccessTo = (access?: string[]) => {
  return checkAccess(resourceAccess.value, access) || sessionStore.isSuperAdmin;
};
</script>

<template>
  <AppNavigation :title="t('title.defaultAdminShort')" :logo="logo">
    <template #main>
      <AppNavigationItems
        :routes="mainRoutes"
        :current-route="currentRoute"
        :authenticated="isAuthenticated"
        :has-access-to="hasAccessTo"
      />
    </template>
    <template #footer>
      <AppNavigationItems
        :routes="footerRoutes"
        :current-route="currentRoute"
        :authenticated="isAuthenticated"
        :has-access-to="hasAccessTo"
      />
      <template v-if="isAuthenticated && currentUser">
        <AdminNotificationsNav :authenticated="isAuthenticated" />
        <NavItem
          :action="logout"
          menu-key="logout"
          :label="t('nav.logout')"
          icon="fa-light fa-sign-out"
        />
        <NavItem
          menu-key="user-menu"
          :avatar="true"
          :label="currentUser.username"
          class="user-menu mt-1"
        />
      </template>
    </template>
  </AppNavigation>
</template>
